module.exports = __webpack_public_path__ + "static/media/headerImage1.b8c9b84d.png";